import React, { useState } from 'react'
import IconHeading from '../../../components/ui/IconHeading'
import OpenStack from '../../book-management/book-list/components/OpenStack'
import ChangePage from '../../../components/function/ChangePage'

const BookList = ({ books }) => {
  const ITEMS_PER_PAGE = 5

  const [currentPage, setCurrentPage] = useState(1)

  const resetPage = () => {
    setCurrentPage(1) // Reset trang về 1 khi đóng modal
  }
  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  const paginatedDownloadedBooks =
    books?.downloaded?.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      currentPage * ITEMS_PER_PAGE
    ) || []

  const paginatedUploadedBooks =
    books?.uploaded?.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      currentPage * ITEMS_PER_PAGE
    ) || []

  const tableHeaderUploadedBooks = [
    'STT',
    'Tiêu đề',
    'Kích thước file & thiết bị tải lên',
    'Ngày tải lên',
    'Lần đồng bộ cuối',
  ]
  const tableHeaderDownloadedBooks = [
    'STT',
    'Tiêu đề',
    'Tác Giả',
    'Ngày tải về',
    'Lần đồng bộ cuối',
  ]


  return (
    <>
      <section className="mt-8 flex gap-16">
        <div className="flex flex-1 flex-col">
          <div className="flex w-full justify-between">
            <IconHeading
              icon="ph:book"
              title="SÁCH ĐÃ TẢI"
              className="ml-2 text-lg"
              {...(books?.downloaded?.length > 0 && {
                number: books.downloaded.length,
              })}
            />
            <OpenStack
              title={`SÁCH ĐÃ TẢI (${books?.downloaded?.length || 0})`}
              onClose={resetPage}
            >
              <section className="flex h-full flex-col justify-between">
                <div className="h-[60vh]">
                  {books?.downloaded?.length > 0 ? (
                    <table className="min-w-full border-collapse">
                      <thead className="bg-[#c2c2c2]">
                        <tr>
                          {tableHeaderDownloadedBooks.map((header, index) => (
                            <th
                              key={index}
                              className="border border-[#999] px-4 py-6 text-left"
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedDownloadedBooks.map((book, index) => (
                          <tr key={book.id} className="bg-[#f2f2f2]">
                            <td className="border border-[#999] px-4 py-6">
                              {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                            </td>
                            <td className="border border-[#999] px-4 py-6">
                              {book.title}
                            </td>
                            <td className="border border-[#999] px-4 py-6">
                              {book.author}
                            </td>
                            <td className="border border-[#999] px-4 py-6">
                              {new Date(book.downloadDate).toLocaleDateString()}
                            </td>
                            <td className="border border-black px-4 py-2">
                              {new Date(book.lastSync).toLocaleDateString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p className="mt-4 text-center text-sm text-gray-500">
                      Hiện tại chưa có sách tải về
                    </p>
                  )}
                </div>
                <div className="mt-4">
                  <ChangePage
                    currentPage={currentPage}
                    totalItems={books?.downloaded?.length || 0}
                    itemsPerPage={ITEMS_PER_PAGE}
                    onPageChange={handlePageChange}
                    totalPages={Math.ceil(
                      (books?.downloaded?.length || 0) / ITEMS_PER_PAGE
                    )}
                    objectName={'sách đã tải'}
                  />
                </div>
              </section>
            </OpenStack>
          </div>
          <div className="mt-4 max-h-[20vh] overflow-scroll">
            {books?.downloaded?.length > 0 ? (
              books.downloaded.map((book) => (
                <p key={book.id} className="max-w-[50ch] truncate text-sm">
                  {book.title}
                </p>
              ))
            ) : (
              <p className="mt-4 text-center text-sm text-gray-500">
                Hiện tại chưa có sách tải về
              </p>
            )}
          </div>
        </div>
        <div className="flex flex-1 flex-col">
          <div className="flex w-full justify-between">
            <IconHeading
              icon="ph:upload-simple"
              title="TÀI LIỆU ĐÃ TẢI LÊN"
              className="ml-2 text-lg"
              {...(books?.uploaded?.length > 0 && {
                number: books.uploaded.length,
              })}
            />
            <OpenStack
              title={`TÀI LIỆU ĐÃ TẢI LÊN (${books?.uploaded?.length || 0})`}
              onClose={resetPage}
            >
              <section className="flex flex-col justify-between">
                <div className="h-[60vh]">
                  {books?.uploaded?.length > 0 ? (
                    <table className="min-w-full border-collapse">
                      <thead className="bg-[#c2c2c2]">
                        <tr>
                          {tableHeaderUploadedBooks.map((header, index) => (
                            <th
                              key={index}
                              className="border border-[#999] px-4 py-6 text-left"
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedUploadedBooks.map((book, index) => (
                          <tr key={book.id} className="bg-[#f2f2f2]">
                            <td className="border border-[#999] px-4 py-6">
                              {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                            </td>
                            <td className="border border-[#999] px-4 py-6">
                              {book.title}
                            </td>
                            <td className="border border-[#999] px-4 py-6">{`${book.fileSize} - ${book.uploadDevice}`}</td>
                            <td className="border border-[#999] px-4 py-6">
                              {new Date(book.uploadDate).toLocaleDateString()}
                            </td>
                            <td className="border border-[#999] px-4 py-6">
                              {new Date(book.lastSync).toLocaleDateString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p className="mt-4 text-center text-sm text-gray-500">
                      Hiện tại chưa có sách tải lên
                    </p>
                  )}
                </div>
                <div className="mt-4">
                  <ChangePage
                    currentPage={currentPage}
                    totalItems={books?.uploaded?.length || 0}
                    itemsPerPage={ITEMS_PER_PAGE}
                    onPageChange={handlePageChange}
                    totalPages={Math.ceil(
                      (books?.uploaded?.length || 0) / ITEMS_PER_PAGE
                    )}
                    objectName={'tài liệu đã tải lên'}
                  />
                </div>
              </section>
            </OpenStack>
          </div>
          <div className="mt-4 max-h-[20vh] overflow-scroll">
            {books?.uploaded?.length > 0 ? (
              books.uploaded.map((book) => (
                <p key={book.id} className="max-w-[50ch] truncate text-sm">
                  {book.title}
                </p>
              ))
            ) : (
              <p className="mt-4 text-center text-sm text-gray-500">
                Hiện tại chưa có sách tải lên
              </p>
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default BookList
